export const ADMISSION_FILTER = 'ADMISSION_FILTER';
export const ADMISSION_AED_VIEW_LOCATION_FILTER = 'ADMISSION_AED_VIEW_LOCATION_FILTER';
export const ADMISSION_AED_VIEW_SHOW_DETAILS = 'ADMISSION_AED_VIEW_SHOW_DETAILS';
export const ADMISSION_SOPD_VIEW_SHOW_DETAILS = 'ADMISSION_SOPD_VIEW_SHOW_DETAILS';
export const ADMISSION_TRANSFER_IN_FILTER = 'ADMISSION_TRANSFER_IN_FILTER';
